import React from 'react';
import LazyMetrics from '../../states-year/LazyMetrics';
import ProjectActivityYear from '../../states-year/Projects/ProjectActivityYear';
import ProjectResponseYear from '../../states-year/Projects/ProjectResponseYear';
import ProjectStatusYear from '../../states-year/Projects/ProjectStatusYear';
import TotalYear from '../../states-year/Projects/TotalYear';
import StudentsYear from '../../states-year/Projects/StudentsYear';
import QuestionsByMonth from '../../states-year/Projects/QuestionsByMonth';
import QuestionCreatorYear from '../../states-year/Projects/QuestionCreatorYear';
import QuestionDeclinerYear from '../../states-year/Projects/QuestionDeclinerYear';
import QuestionDeclineReasonYear from '../../states-year/Projects/QuestionDeclineReasonYear';
import ProjectSubjectYear from '../../states-year/Projects/ProjectSubjectYear';

export default function Projects(props) {
  const { params } = props;

  return (
    <>
      <LazyMetrics
        title="Projects"
        columns={1}
      >
        {/*<ProjectActivityYear {...params} />*/}
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <ProjectResponseYear {...params} />
          <ProjectStatusYear {...params} />
          <ProjectSubjectYear {...params} />
        </div>
        <ProjectActivityYear {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <TotalYear {...params} titleOnly={true} />
          <StudentsYear {...params} titleOnly={true} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title="Invitations - Projects"
        columns={1}
      >
        <QuestionsByMonth {...params} />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          <QuestionCreatorYear {...params} />
          <QuestionDeclinerYear {...params} />
        </div>
        <QuestionDeclineReasonYear {...params} />
      </LazyMetrics>
    </>
  );
}
